export enum CheckoutTypes {
    INFO = "INFO",
    REVIEW = "REVIEW",
    ORDERSUBMITTED = "ORDERSUBMITTED"
}